/**
 * Labstep
 *
 * @module components/Layout/FullScreen
 * @desc Labstep Layout
 */

import classnames from 'classnames';
import { LayoutAlert as Alerts } from 'labstep-web/components/Layout/Alert';
import { LayoutFullPageError as FullPageError } from 'labstep-web/components/Layout/FullPageError';
import { LinksActiveGroup as Links } from 'labstep-web/components/Layout/FullScreen/Links';
import { MainContent } from 'labstep-web/components/Layout/MainContent';
import LeftMenu from 'labstep-web/components/Layout/Menu/Left';
import { ErrorBoundaryContainer } from 'labstep-web/containers/ErrorBoundary';
import type React from 'react';
import styles from './styles.module.scss';
import type { FullScreenLayoutProps, FullScreenProps } from './types';

export const FullScreenLayout: React.FC<FullScreenLayoutProps> = ({
  right,
}) => (
  <div id="parent-container" className={styles.parentContainer}>
    <div id="main-content" className={styles.mainContent}>
      <div id="right" className={styles.right}>
        <div className={styles.topbar} />
        {right}
      </div>
    </div>
  </div>
);

export const LeftDesktop = () => (
  <div id="left" className={classnames(styles.left)}>
    <div className={styles.leftMain}>
      <Links desktop />
    </div>
  </div>
);

export const FullScreen: RFC<FullScreenProps> = ({
  children,
  ...rest
}) => (
  <div id="parent-container" className={styles.parentContainer}>
    <div>
      <Alerts />
    </div>
    <div id="main-content" className={styles.mainContent}>
      <LeftMenu />
      <div id="right" className={styles.right}>
        <MainContent center={children} {...rest} />
      </div>
    </div>
  </div>
);

export const FullScreenWithErrorBoundary: RFC<FullScreenProps> = (
  props,
) => (
  <ErrorBoundaryContainer
    FallbackComponent={<FullPageError showSignout />}
  >
    <FullScreen {...props} />
  </ErrorBoundaryContainer>
);
